export const BASE_URL = 'https://server-express-foodapp.herokuapp.com/api';
export const ACCESS_TOKEN = 'accessTokenPartner';
